// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  worldId: __t.string().name("world_id"),
  cellX: __t.u32().name("cell_x"),
  cellY: __t.u32().name("cell_y"),
  ownerPlayerId: __t.string().name("owner_player_id"),
  updatedTick: __t.u64().name("updated_tick"),
});
